import { getData } from '../utils/data';

/**
 * Home banner specifics.
 */
export default function homeBannerSection() {
  if (!document.getElementById('homeBannerHeroText')) return; 

  const container = document.getElementById('homeBannerHeroText').querySelector('.animated');
  if (!container) return;

  const words = container.dataset.textItems.split(',');
  if (!words.length) return;
  
  const speed = 48;

  let pause = 4000;

  let word = words[0];
  let letters = word;
  let phase = 1;

  container.innerHTML = letters;
  
  // Get the swiper instance (use an interval because swipers load asynchronously)
  const homeBanner = document.querySelector('#homeBanner div[data-sw-swiper]');
  let homeSwiper;
  let _sethbs = setInterval(() => {
    homeSwiper = getData(homeBanner, 'swiperinstance');
    if (homeSwiper) clearInterval(_sethbs);
  }, 200);
  
  setInterval(() => {

    // if the body is locked don't animate (?)
    // if (document.body.classList.contains('locked')) return;

    if (phase === 0) {

      // clear block, start typing the word
      container.innerHTML = '&nbsp;';
      phase = 1;
    } else if (phase === 1) {

      if (letters === word) {

        // set to waiting phase
        phase = -1;

        // wait pause
        setTimeout(() => phase = 2, pause);
      } else {

        // type in
        let letter = letters === '' ? word.charAt(0) : word.split(letters)[1].charAt(0);
        letters += letter;
        container.innerHTML = letters;
      }
    } else if (phase === 2) {

      if (letters === '') {

        // next word
        let wi = words.indexOf(word);
        word = words[(wi === words.length - 1) ? 0 : wi + 1];

        // reset phase
        phase = 0;
      } else {

        // progress swiper
        if (letters === word) {
          if (homeSwiper) homeSwiper.slideNext();
        }

        // type out
        letters = letters.substring(0, letters.length - 1);
        container.innerHTML = letters === '' ? '&nbsp;' : letters;
      }
    }
  }, speed);
}


// WEBPACK FOOTER //
// ./source/scripts/sections/home-banner.js